<div class="certifications-card">
  <!-- Error Message -->
  @if (errorMessage) {
  <div class="alert alert-danger alert-dismissible fade show" role="alert">
    <i class="bi bi-exclamation-triangle-fill me-2"></i>
    {{ errorMessage }}
    <button type="button" class="btn-close" aria-label="Close" (click)="errorMessage = ''"></button>
  </div>
  }

  <!-- Header Actions -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h5 class="mb-0">
      <i class="bi bi-patch-check me-2"></i>
      Certifications
      <span class="badge bg-secondary ms-2">{{ certifications.length }}</span>
    </h5>
    <button class="btn btn-primary" (click)="openUploadModal()" [disabled]="loading">
      <i class="bi bi-plus-circle me-1"></i>
      Upload Certificate
    </button>
  </div>

  <!-- Loading State -->
  @if (loading){
  <div class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2 text-muted">Loading certifications...</p>
  </div>
  }

  <!-- Certifications Section -->
  @if (!loading && !errorMessage) {
  <div class="mb-4">
    <!-- Empty State -->
    @if (certifications.length === 0) {
    <div class="text-center py-5 text-muted">
      <i class="bi bi-file-earmark-text fs-1 d-block mb-3"></i>
      <p>No certifications uploaded yet</p>
      <button class="btn btn-primary" (click)="openUploadModal()">
        <i class="bi bi-plus-circle me-1"></i>
        Upload First Certificate
      </button>
    </div>
    }

    <!-- Certifications Table -->
    @if (certifications.length > 0){
    <div>
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th>Cert Type</th>
            <th>Certificate Number</th>
            <th>Status</th>
            <th>Expires</th>
            <th>Files</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (cert of certifications; track cert.id) {
          <tr>
            <td>
              <strong>{{ getCertificationTypeName(cert.certificationType) }}</strong>
              @if (cert.state) { <div class="small text-muted">{{ cert.state }}</div> }
            </td>
            <td>
              <span class="font-monospace">{{ cert.certificateNumber }}</span>
            </td>
            <td>
              <span [class]="'badge text-uppercase fw-semibold ' + getStatusClass(cert)">
                {{ getStatusIcon(cert) }} {{ getStatusText(cert) }}
              </span>
            </td>
            <td>{{ formatDate(cert.expirationDate) }}</td>
            <td>
              @if (getFileCount(cert) > 0) {
              <span class="text-muted">
                <i class="bi bi-file-earmark-pdf"></i> {{ getFileCount(cert) }}
              </span>
              } @else {
              <span class="text-muted">-</span>
              }
            </td>
            <td>
              <div class="dropdown">
                <button
                  class="btn btn-sm btn-outline-secondary"
                  type="button"
                  [id]="'certActions' + cert.id"
                  data-bs-toggle="dropdown"
                  aria-expanded="false">
                  <i class="bi bi-three-dots-vertical"></i>
                </button>
                <ul class="dropdown-menu shadow" [attr.aria-labelledby]="'certActions' + cert.id">
                  <li>
                    <button
                      class="dropdown-item"
                      (click)="viewCertificate(cert)"
                      [disabled]="!cert.documentUrl">
                      <i class="bi bi-eye me-2"></i>View Certificate
                    </button>
                  </li>
                  <li>
                    <button class="dropdown-item" (click)="editCertification(cert)">
                      <i class="bi bi-pencil me-2"></i>Edit
                    </button>
                  </li>
                  <li><hr class="dropdown-divider"></li>
                  <li>
                    <button class="dropdown-item text-danger" (click)="deleteCertification(cert)">
                      <i class="bi bi-trash me-2"></i>Delete
                    </button>
                  </li>
                </ul>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    }
  </div>
  }

  <!-- Upload Modal -->
   @if (showUploadModal) {
  <app-certification-upload-modal
    [organizationId]="organizationId"
    [profileId]="userId"
    [certification]="editingCertification"
    (close)="closeUploadModal()"
    (uploaded)="onCertificationUploaded()">
  </app-certification-upload-modal>
  }
</div>
